// 快递单模板
import httpClient from "@/services/http/mainServerClient";

import LogisticsCompany from "@/enum/LogisticsCompany";

import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";

// 获取列表
export function getList(): Promise<WaybillTemplateDTO[]> {
    return httpClient.get(`/waybillTemplate`);
}

// 通过id获取单个模板
export function getTemplateById(templateId: any): Promise<WaybillTemplateDTO> {
    return httpClient.get(`/waybillTemplate/${templateId}`);
}
// 更新模板
export function updateTemplate(template: WaybillTemplateDTO): Promise<WaybillTemplateDTO> {
    const { id } = template;
    return httpClient.post(`/waybillTemplate/update/${id}`, template);
}

export function updateTemplateName(templateId: number, name: string): Promise<WaybillTemplateDTO> {
    return httpClient.post(`/waybillTemplate/${templateId}:updateName`, { name });
}

// 删除模板
export function deleteTemplate(templateId: any) {
    return httpClient.post(`/waybillTemplate/delete/${templateId}`);
}
// 绑定打印机
export function bindPrinter({ templateId, printer }: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:bindPrinter`, {
        printer,
    });
}
// 解绑打印机
export function unbindPrinter(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:unbindPrinter`);
}
// 绑定店铺
export function bindShop({ templateId, shopIds }: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:bindShop`, {
        shopIds,
    });
}
// 解绑店铺
export function unbindShop(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:unbindShop`);
}
// 复制模板
export function copyTemplate(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:copy`);
}
// 更新默认发货地址
export function updateDefaultShippingAddress({ templateId, defaultShippingAddressId }: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:updateDefaultShippingAddress`, {
        defaultShippingAddressId,
    });
}
// 删除默认发货地址
export function deleteDefaultShippingAddress(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:deleteDefaultShippingAddress`);
}
// 开启空大头笔检查
export function enableEmptyShortAddressCheck(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:enableEmptyShortAddressCheck`);
}
// 关闭空大头笔检查
export function disableEmptyShortAddressCheck(templateId: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:disableEmptyShortAddressCheck`);
}
// 设置可以使用该模板的店铺
export function setAllowedShops({ templateId, shopIds }: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:setAllowedShops`, {
        shopIds,
    });
}
// 更新序号
export function updateIndex({ templateId, index }: any) {
    return httpClient.post(`/waybillTemplate/${templateId}:updateIndex`, {
        index,
    });
}

export interface CreateWaybillTemplateParams {
    // 快递公司
    logisticsCompany: LogisticsCompany;
    // 模板名称
    name: string;
    // 纸张宽度
    width: number;
    // 纸张长度
    height: number;
    // 面单图片
    picture?: File;
}

// 创建普通模板
export function create(params: CreateWaybillTemplateParams): Promise<WaybillTemplateDTO> {
    const formData = new FormData();

    Object.entries(params).map(([key, value]) => {
        value && formData.append(key, value);
    });

    return httpClient.post(`/waybillTemplate`, formData, { timeout: 60000 });
}

export interface QnCreateWaybillTemplateParams {
    // 快递公司
    logisticsCompany: LogisticsCompany;
    // 模板名称
    name: string;
    // 纸张宽度
    width: number;
    // 纸张长度
    height: number;
    // 面单图片

    pictureFileSize?: number;

    pictureOriginalName?: string;

    pictureUrl?: string;
}

// 创建普通模板
export function qnCreate(params: QnCreateWaybillTemplateParams): Promise<WaybillTemplateDTO> {
    return httpClient.post(`/waybillTemplate/qianniu/waybillTemplate`, params);
}

// 获取系统模板列表
export function getSystemListByLogisticsCompany(logisticsCompany: LogisticsCompany): Promise<WaybillTemplateDTO[]> {
    return httpClient.get(`/waybillTemplate/listSystem`, {
        logisticsCompany,
    });
}

// 复制系统模板
export function copySystemTemplate({
    systemTemplateId,
    ewaybillShippingAddressId,
    serviceOptionValues,
    ewaybillAccountId,
}: {
    systemTemplateId: number | string;
    ewaybillShippingAddressId?: string | number;
    serviceOptionValues?: string;
    ewaybillAccountId?: number;
}): Promise<WaybillTemplateDTO> {
    return httpClient.post(`/waybillTemplate/${systemTemplateId}:copySystem`, {
        ewaybillShippingAddressId,
        serviceOptionValues,
        ewaybillAccountId,
    });
}

interface UpdateTemplateEwaybillShippingAddressBody {
    templateId: number;
    ewaybillShippingAddressId: number;
    serviceOptionValues: string;
}

export function updateTemplateEwaybillShippingAddress(body: UpdateTemplateEwaybillShippingAddressBody) {
    return httpClient.post<WaybillTemplateDTO>(`/waybillTemplate/${body.templateId}:updateEwaybillShippingAddress`, {
        ewaybillShippingAddressId: body.ewaybillShippingAddressId,
        serviceOptionValues: body.serviceOptionValues,
    });
}

export function recoveryWaybillTemplate(id: number) {
    return httpClient.post(`/waybillTemplate/recovery/${id}`);
}

export default {
    getList,
    getTemplateById,
    updateTemplate,
    deleteTemplate,
    bindPrinter,
    unbindPrinter,
    bindShop,
    unbindShop,
    copyTemplate,
    updateDefaultShippingAddress,
    deleteDefaultShippingAddress,
    enableEmptyShortAddressCheck,
    disableEmptyShortAddressCheck,
    setAllowedShops,
    updateIndex,
    create,
    qnCreate,
    getSystemListByLogisticsCompany,
    copySystemTemplate,
};
